import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Search, ArrowRight, Calendar } from 'lucide-react';
import { noticiaService } from '../services/api';
import './Noticias.css';

const CATEGORIAS = ['Todas', 'noticias', 'eventos', 'projetos', 'educacao', 'saude', 'social'];

export default function Noticias() {
  const [noticias,   setNoticias]   = useState<any[]>([]);
  const [pagina,     setPagina]     = useState(1);
  const [totalPags,  setTotalPags]  = useState(1);
  const [categoria,  setCategoria]  = useState('Todas');
  const [busca,      setBusca]      = useState('');
  const [loading,    setLoading]    = useState(true);
  const LIMITE = 9;

  useEffect(() => {
    setLoading(true);
    const params: any = { limite: LIMITE, pagina };
    if (categoria !== 'Todas') params.categoria = categoria;
    noticiaService.listar(params)
      .then(r => {
        setNoticias(r.data.noticias || []);
        setTotalPags(r.data.totalPaginas || 1);
      })
      .catch(() => setNoticias([]))
      .finally(() => setLoading(false));
  }, [pagina, categoria]);

  const filtradas = busca.trim()
    ? noticias.filter(n => n.titulo.toLowerCase().includes(busca.toLowerCase()))
    : noticias;

  return (
    <main>
      <div className="page-hero">
        <h1>Notícias</h1>
        <p>Fique por dentro das ações, eventos e conquistas do Instituto Mãos Estendidas.</p>
      </div>

      <section className="section-pad">
        <div className="container">
          {/* Filters */}
          <div className="noticias-filters">
            <div className="search-box">
              <Search size={17} />
              <input
                type="text"
                placeholder="Buscar notícia..."
                value={busca}
                onChange={e => setBusca(e.target.value)}
              />
            </div>
            <div className="cat-pills">
              {CATEGORIAS.map(c => (
                <button
                  key={c}
                  className={`cat-pill ${categoria === c ? 'active' : ''}`}
                  onClick={() => { setCategoria(c); setPagina(1); }}
                >
                  {c === 'Todas' ? 'Todas' : c.charAt(0).toUpperCase() + c.slice(1)}
                </button>
              ))}
            </div>
          </div>

          {loading ? (
            <div className="loading-center"><div className="spinner" /><p>Carregando notícias…</p></div>
          ) : filtradas.length === 0 ? (
            <div className="loading-center"><p>Nenhuma notícia encontrada.</p></div>
          ) : (
            <>
              <div className="grid-3">
                {filtradas.map((n: any, i: number) => (
                  <Link to={`/noticias/${n.slug}`} className="card noticia-list-card" key={n._id} style={{ animationDelay: `${i * 0.07}s` }}>
                    {n.imagemUrl && (
                      <div className="noticia-list-img">
                        <img src={n.imagemUrl} alt={n.titulo} loading="lazy" />
                        {n.categoria && <span className="noticia-cat-badge">{n.categoria}</span>}
                      </div>
                    )}
                    <div className="noticia-list-body">
                      <div className="noticia-meta">
                        <span className="noticia-data-pill">
                          <Calendar size={12} />
                          {new Date(n.criadoEm).toLocaleDateString('pt-BR', { day:'2-digit', month:'short', year:'numeric' })}
                        </span>
                        {n.autor && <span className="noticia-autor">Por {n.autor}</span>}
                      </div>
                      <h3>{n.titulo}</h3>
                      {n.subtitulo && <p>{n.subtitulo}</p>}
                      <span className="noticia-ler">Leia mais <ArrowRight size={14} /></span>
                    </div>
                  </Link>
                ))}
              </div>

              {/* Pagination */}
              {totalPags > 1 && (
                <div className="pagination">
                  <button disabled={pagina === 1} onClick={() => setPagina(p => p - 1)}>‹</button>
                  {Array.from({ length: totalPags }, (_, i) => i + 1).map(p => (
                    <button key={p} className={pagina === p ? 'active' : ''} onClick={() => setPagina(p)}>{p}</button>
                  ))}
                  <button disabled={pagina === totalPags} onClick={() => setPagina(p => p + 1)}>›</button>
                </div>
              )}
            </>
          )}
        </div>
      </section>
    </main>
  );
}